import {Component, Inject, Input} from '@angular/core';
import {AbstractComponent, ConfirmationModalComponent} from "@components";
import {AuthenticationService, EventService, ExportService, LeagueService, LoaderService, TOAST_STATE, ToastService} from "@services";
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, Router} from "@angular/router";
import {EventFilter, FindEventsRequest, League, Lookups, PagedFilter} from "@model";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ADD, EDIT} from "../../../../../app-routing.module";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-list-of-leagues-statements',
  templateUrl: './list-of-leagues.component.html',
  styleUrls: ['./list-of-leagues.component.scss']
})
export class ListOfLeaguesComponent extends AbstractComponent {
  @Input() leagues: League[] = [];
  @Input({required: true}) languages: Lookups[] = [];

  constructor(private toastService: ToastService, private translocoService: TranslocoService, private router: Router,
              private leagueService: LeagueService, private loaderService: LoaderService,
              public authService: AuthenticationService,private modalService: NgbModal,
              private route: ActivatedRoute, private exportService: ExportService, @Inject(DOCUMENT) private document: Document
  ) {
    super();
  }

  goToLeagueDetails(league: League): void {
    if (league && league.id) {
      this.router.navigate([EDIT], {queryParams: {leagueId: league.id}, relativeTo:this.route});
    }
  }

  openDeleteLeagueDialog(league: League):void {
    const modalRef: NgbModalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.title = this.translocoService.translate("leagues.delete.dialog.title");
    modalRef.componentInstance.text = this.translocoService.translate("leagues.delete.dialog.text");

    modalRef.result.then((_) => {
     this.deleteLeague(league);
    }, (_) => {
      /// ignore
    });
  }
  getFileFromServer(type: string) {
    this.exportService.downloadLeagues(type, this.createFilter()).subscribe(
      (blob: Blob) => {
        const formattedDateTime: string = this.getCurrentDateTimeFormatted();
        const filename: string = type + '_' + formattedDateTime + '.' + type;
        const downloadLink: HTMLAnchorElement = this.document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);
        this.document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }

  createFilter() {
    return FindEventsRequest.createEventPageFilter(
      0,
      {
        dateFrom: undefined,
        dateTo: undefined,
        sport: undefined,
        selectedMonth: undefined,
        length: undefined,
      });
  }

  getCurrentDateTimeFormatted(): string {
    const currentDateTime = new Date();
    const year = currentDateTime.getFullYear();
    const month = this.padNumber(currentDateTime.getMonth() + 1, 2);
    const day = this.padNumber(currentDateTime.getDate(), 2);
    return `${year}-${month}-${day}`;
  }

  padNumber(num: number, size: number): string {
    let numStr = num.toString();
    while (numStr.length < size) {
      numStr = '0' + numStr;
    }
    return numStr;
  }

  deleteLeague(league: League): void {
    this.loaderService.startLoading();
    this.leagueService.deleteLeague(league, () => {
      this.leagueService.findLeagues().subscribe((leagues: League[]):void => {
        this.leagues = leagues;
        this.loaderService.dismissLoading();
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("leagues.delete.success"));
      });
    }, () => {
      this.loaderService.dismissLoading();
      this.toastService.showToast(TOAST_STATE.danger,
        this.translocoService.translate("leagues.delete.error"));
    });
  }

  goToAddLeague(): void {
    this.router.navigate([ADD], {relativeTo:this.route});
  }
}
